import { Pipe, PipeTransform } from '@angular/core';
import { PlayerService } from './player/services/player.service';

@Pipe({
    name: 'nowplaying'
})
export class NowPlayingPipe implements PipeTransform {

    constructor(private playerService: PlayerService) {

    }

    transform(value: any, args?: any): any {
        let tooltip = this.playerService.getRadioCurrentSong(value);
        return tooltip;
    }

}



// WEBPACK FOOTER //
// ./src/app/now-playing.pipe.ts